/**
 * Localized copy for the WhatsApp chat-qualify demo (the example solar-installer
 * conversation). Plain module — NO 'use client' — so it can be called from both
 * the Server Component hero and the client funnel showcase. Resolves keys from
 * the `selenos` next-intl namespace.
 */

export interface ChatQualifyCopy {
  business: string;
  status: string;
  typing: string;
  m1: string; // agent opener
  m2: string; // lead reply
  m3: string; // agent qualifier
  m4: string; // lead reply
  m5: string; // agent verdict
  qualified: string;
  example: string;
  inputPlaceholder: string;
}

/** Build the chat script from a next-intl translator (works server or client). */
export function buildChatCopy(t: (key: string) => string): ChatQualifyCopy {
  return {
    business: t('animQualifyBiz'),
    status: t('animQualifyStatus'),
    typing: t('animQualifyTyping'),
    m1: t('animQualifyM1'),
    m2: t('animQualifyM2'),
    m3: t('animQualifyM3'),
    m4: t('animQualifyM4'),
    m5: t('animQualifyM5'),
    qualified: t('animQualifyQualified'),
    example: t('animQualifyExample'),
    inputPlaceholder: t('animQualifyInput'),
  };
}
